<template>
    <flex-container :gap="Size.lg">
        <flex-container justify-content="space-between" align-items="center">
            <flex-container size="auto" :gap="Size.xs">
                <text-heading>
                    <span v-if="command.name.length > 0">{{ command.name }}</span>
                    <span v-else-if="props.templateId">Template wijzigen</span>
                    <span v-else>Template toevoegen</span>
                </text-heading>
            </flex-container>

            <flex-container size="auto" justify-content="flex-end">
                <button-outline @click="backToLister">
                    Annuleren
                </button-outline>

                <button-block :disabled="!commandIsValid" @loading="saveTemplate">
                    Template opslaan
                </button-block>
            </flex-container>
        </flex-container>
    </flex-container>

    <horizontal-line />

    <flex-container>
        <flex-container :size="10">
            <card-normal>
                <flex-container :gap="Size.xl" align-items="flex-end">
                    <flex-container :size="5">
                        <input-group v-model="command.name" :schema="reach(command.validationSchema, 'name') as Schema">
                            <template #label>
                                <input-label>
                                    Naam template
                                </input-label>
                            </template>
                            <template #input>
                                <text-input :placeholder="documentPlaceholder" />
                            </template>
                        </input-group>
                    </flex-container>

                    <flex-container :size="5">
                        <input-group v-model="command.active">
                            <template #input>
                                <flex-container :gap="Size.sm" align-items="center">
                                    <switch-input variant="small" />
                                    <span>Actief</span>
                                </flex-container>
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>

                <template v-if="isConfigurable">
                    <horizontal-line />

                    <flex-container :gap="Size.xl">
                        <flex-container :size="5">
                            <flex-container :size="5">
                                <img
                                    v-if="logo && logo.url"
                                    class="logo-preview"
                                    :src="logo.url"
                                    alt=""
                                />
                            </flex-container>

                            <flex-container
                                :size="5"
                                align-content="center"
                                justify-content="flex-end"
                            >
                                <button-block without-loading @completed="changeLogoModal?.openOverlay();">
                                    <span v-if="logo">Veranderen</span>
                                    <span v-else>Logo uploaden</span>
                                </button-block>

                                <button-outline
                                    v-if="logo"
                                    :color="Color.red500"
                                    @click="logo = null"
                                >
                                    Verwijderen
                                </button-outline>
                            </flex-container>
                        </flex-container>

                        <flex-container :size="5" align-content="end">
                            <input-group v-model="command.payload.nvmLogoVisible">
                                <template #input>
                                    <flex-container :gap="Size.sm" align-items="center">
                                        <switch-input variant="small" />

                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox="0 0 35 50"
                                            height="20"
                                            fill="#015ad2"
                                        >
                                            <path d="M9.705 38.242v11.505h-.77l-6.54-6.984v6.779H.084V38.037h.753l6.557 6.951v-6.746h2.311m12.363 0-5.033 11.505h-.771l-5.05-11.505h2.62l2.824 6.849 2.808-6.849h2.602m12.585-.205v11.505h-2.311v-6.027l-2.843 3.562h-.753l-2.842-3.562v6.027h-2.311V38.037h.753l4.777 6.112 4.777-6.112h.753M32.106.097c1.394 0 2.524 1.112 2.524 2.484v30.707a1.39 1.39 0 0 1-1.4 1.377h-7.692c-.774 0-1.4-.616-1.4-1.377V22.743c0-1.566 1.289-2.835 2.88-2.835h.287c2.603 0 4.714-2.077 4.714-4.64 0-2.563-2.111-4.64-4.714-4.64s-4.713 2.077-4.713 4.64l.017 18.02a1.39 1.39 0 0 1-1.4 1.377h-7.681c-.773 0-1.4-.616-1.4-1.377l.017-18.02c0-2.563-2.11-4.64-4.714-4.64-2.603 0-4.713 2.077-4.713 4.64 0 2.563 2.11 4.64 4.713 4.64h.288c1.59 0 2.88 1.27 2.88 2.835v10.545c0 .76-.626 1.377-1.4 1.377H1.506a1.39 1.39 0 0 1-1.4-1.377V2.58C.106 1.209 1.236.097 2.63.097l10.376.012c2.03 0 3.677 1.621 3.677 3.619l-.187.06c-2.146.403-3.768 2.262-3.768 4.492 0 2.526 2.08 4.574 4.647 4.574h-.012c2.566 0 4.645-2.048 4.645-4.574 0-2.23-1.622-4.089-3.768-4.492l-.187-.06C18.053 1.73 19.7.109 21.73.109L32.106.097" />
                                        </svg>

                                        <span v-if="command.payload.nvmLogoVisible">Zichtbaar</span>
                                        <span v-else>Verborgen</span>
                                    </flex-container>
                                </template>
                            </input-group>
                        </flex-container>
                    </flex-container>

                    <horizontal-line />

                    <flex-container :gap="Size.lg">
                        <flex-container :gap="Size.xl">
                            <flex-container :size="5">
                                <input-group v-model="command.payload.primaryColor">
                                    <template #label>
                                        <input-label>
                                            Primaire kleur
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <color-input v-model="command.payload.primaryColor" />
                                    </template>
                                </input-group>
                            </flex-container>

                            <flex-container :size="5">
                                <input-group v-model="command.payload.primaryTextColor">
                                    <template #label>
                                        <input-label>
                                            Primaire tekst kleur
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <color-input v-model="command.payload.primaryTextColor" />
                                    </template>
                                </input-group>
                            </flex-container>
                        </flex-container>

                        <flex-container :gap="Size.xl">
                            <flex-container :size="5">
                                <input-group v-model="command.payload.secondaryColor">
                                    <template #label>
                                        <input-label>
                                            Secundaire kleur
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <color-input v-model="command.payload.secondaryColor" />
                                    </template>
                                </input-group>
                            </flex-container>

                            <flex-container :size="5">
                                <input-group v-model="command.payload.secondaryTextColor">
                                    <template #label>
                                        <input-label>
                                            Secundaire tekst kleur
                                        </input-label>
                                    </template>
                                    <template #input>
                                        <color-input v-model="command.payload.secondaryTextColor" />
                                    </template>
                                </input-group>
                            </flex-container>
                        </flex-container>
                    </flex-container>

                    <horizontal-line />

                    <flex-container no-wrap>
                        <input-group v-model="command.payload.leadAddressVisible" inline>
                            <template #input>
                                <flex-container :gap="Size.sm" align-items="center">
                                    <switch-input variant="small" />
                                    <span>Adres van lead weergeven</span>
                                </flex-container>
                            </template>
                        </input-group>
                        <template v-if="command.payload.leadAddressVisible">
                            <input-group v-model="command.payload.leadAddressAlignment" inline>
                                <template #input>
                                    <flex-container :gap="Size.sm" align-items="center">
                                        <radio-input
                                            variant="small"
                                            value="left"
                                            label="Links uitlijnen"
                                        />
                                        <span>Links uitlijnen</span>
                                    </flex-container>
                                </template>
                            </input-group>
                            <input-group v-model="command.payload.leadAddressAlignment" inline>
                                <template #input>
                                    <flex-container :gap="Size.sm" align-items="center">
                                        <radio-input
                                            variant="small"
                                            value="right"
                                            label="Rechts uitlijnen"
                                        />
                                        <span>Rechts uitlijnen</span>
                                    </flex-container>
                                </template>
                            </input-group>
                        </template>
                    </flex-container>
                </template>
            </card-normal>

            <card-normal v-if="isEditable">
                <flex-container :gap="Size.lg">
                    <flex-container :gap="Size.xl">
                        <flex-container :size="5">
                            <input-group v-model="command.payload.textName">
                                <template #label>
                                    <input-label>
                                        Naam tekst
                                    </input-label>
                                </template>
                                <template #input>
                                    <text-input />
                                </template>
                            </input-group>
                        </flex-container>

                        <flex-container :size="5">
                            <input-group v-model="fontName">
                                <template #label>
                                    <input-label>
                                        Lettertype
                                    </input-label>
                                </template>
                                <template #input>
                                    <select-input :items="availableFontNames" />
                                </template>
                            </input-group>
                        </flex-container>
                    </flex-container>

                    <flex-container>
                        <text-decorator :size="Size.sm">
                            <a
                                href="https://support.keyvue.nl/hc/nl/articles/24518189526289-Syntax"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Leer hier variabelen in te voeren in de tekst.
                            </a>
                        </text-decorator>

                        <input-group v-model="command.payload.text">
                            <template #input>
                                <rich-text-area-input
                                    size="lg"
                                    toolbar="extended"
                                    :mentionables="[]"
                                />
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>
            </card-normal>
        </flex-container>

        <flex-container
            v-if="isEditable"
            :size="10"
            style="flex: 0 0 640px;"
        >
            <card-normal>
                <flex-container :gap="Size.xl">
                    <flex-container :size="5">
                        <input-group v-model="text">
                            <template #label>
                                <input-label>
                                    Tekst
                                </input-label>
                            </template>
                            <template #input>
                                <select-input
                                    :items="availableTexts"
                                    value-key-name="id"
                                    label-key-name="name"
                                />
                            </template>
                        </input-group>
                    </flex-container>

                    <flex-container :size="5">
                        <input-group v-model="layout">
                            <template #label>
                                <input-label v-if="layout.type.value === 'sales'">
                                    Document
                                </input-label>
                                <input-label v-else>
                                    Briefpapier
                                </input-label>
                            </template>
                            <template #input>
                                <select-input
                                    :items="availableLayouts"
                                    value-key-name="id"
                                    label-key-name="name"
                                />
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>
            </card-normal>

            <card-normal>
                <preview-iframe :srcdoc="preview" :size="layout?.size" />
            </card-normal>
        </flex-container>
    </flex-container>

    <modal-dialog
        ref="changeLogoModal"
        label="Logo uploaden"
        description="Kies een logo (png, jpg, svg, etc)"
        :size="4"
    >
        <flex-container :gap="Size.xs" direction="column">
            <text-heading>Logo uploaden</text-heading>
            <text-description>
                Kies een logo (png, jpg, svg, etc)
            </text-description>
        </flex-container>

        <horizontal-line />

        <input-group v-if="!changeLogoModalLogo || !changeLogoModalLogo.url" v-model="changeLogoModalFiles">
            <template #input>
                <file-drop-zone-input
                    direct-upload
                    :direct-upload-callback="uploadLogo"
                />
            </template>
        </input-group>

        <flex-container v-else justify-content="center">
            <img
                :src="changeLogoModalLogo.url"
                class="logo-preview logo-preview--change-modal"
                alt=""
            />
        </flex-container>

        <template #footer>
            <dialog-footer>
                <template v-if="!changeLogoModalLogo">
                    <button-block without-loading @completed="onChangeLogoCancel">
                        Annuleren
                    </button-block>
                </template>

                <template v-else>
                    <button-text :color="Color.red500" @click="onChangeLogoDelete">
                        Verwijderen
                    </button-text>

                    <button-block without-loading @completed="onChangeLogoConfirm">
                        Bevestigen
                    </button-block>
                </template>
            </dialog-footer>
        </template>
    </modal-dialog>
</template>

<script setup lang="ts">
    import {
        ButtonBlock,
        ButtonOutline,
        ButtonState,
        type ButtonStateChangedEvent,
        CardNormal,
        Color,
        type ExposedOverlay,
        FileDropZoneInput,
        FlexContainer,
        HorizontalLine,
        InputGroup,
        InputLabel,
        RadioInput,
        Size,
        SwitchInput,
        TextHeading,
        TextInput,
    } from '@keyvue/one-ui';

    import ColorInput from '@components/Inputs/ColorInput.vue';
    import PreviewIframe from '@views/Document/Template/Detail/PreviewIframe.vue';

    import {
        CreateDocumentTemplateCommand,
        ChangeDocumentTemplateCommand,
        PreviewDocumentTemplateCommand,
        CreateDocumentLogoCommand,
        DocumentLogo,
        DocumentTemplate,
        Layout,
        Text,
    } from '@keyvue/one-api-client';

    import { computed, reactive, ref, toRef, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import useClient from '@composables/useClient';
    import useNotify from '@composables/useNotify';
    import useScalarSelectInput from '@composables/useScalarSelectInput';
    import { reach, Schema } from 'yup';
    import lodash from 'lodash';

    interface Props {
        templateId?: string;
        type?: string;
    }

    const props = defineProps<Props>();
    const router = useRouter();
    const { client, currentUser, currentCompany, getReactiveCollection } = useClient();
    const { notifySaving, notifySaved, notifyError } = useNotify();

    const documentPlaceholder = ref('Brochure 1');
    const documentType = ref(props.type);
    const isConfigurable = ref(true);
    const isEditable = ref(true);

    const initChangeCommand = async (templateId: string) => {
        const template = await client.get(DocumentTemplate, templateId);
        documentType.value = template.layout.type.value;
        isConfigurable.value = template.layout.configurable;
        isEditable.value = template.layout.editable;

        return ChangeDocumentTemplateCommand.fromTemplate(template);
    };

    const initCreateCommand = () => {
        const command = CreateDocumentTemplateCommand.create();

        command.companyId = currentCompany.value?.id.value ?? '';
        command.payload = {
            nvmLogoVisible: true,
            primaryColor: '#01a28d',
            primaryTextColor: '#ffffff',
            secondaryColor: '#01a28d',
            secondaryTextColor: '#ffffff',
            leadAddressVisible: true,
            leadAddressAlignment: 'left',
            fontName: 'Verdana',
            textName: '',
            text: '',
        };
        command.active = true;
        command.createdById = currentUser.value?.id.value ?? '';

        return command;
    };

    const initCommand = async () => {
        if (props.templateId !== undefined) {
            return Promise.resolve(await initChangeCommand(props.templateId));
        }

        return initCreateCommand();
    };

    const command = reactive(await initCommand()) as CreateDocumentTemplateCommand;
    const commandIsValid = computed(() => command.validationSchema.isValidSync(command));

    const logo = ref<DocumentLogo | null>(null);
    watch(logo, () => {
        command.logoId = logo.value ? logo.value.id.value : null;
    });

    if (command.logoId) {
        logo.value = await client.get(DocumentLogo, command.logoId);
    }

    const availableFontNames = computed(() => [
        { value: 'Verdana', label: 'Verdana' },
    ]);
    const fontName = useScalarSelectInput(toRef(command.payload, 'fontName'), availableFontNames);

    const textCollection = await getReactiveCollection(Text, { active: true, type: documentType.value, 'order[name]': 'asc' });
    const availableTexts = computed(() => [
        ...textCollection.data.value,
        { id: 'new', name: 'Nieuwe tekst' },
    ]);
    const text = useScalarSelectInput(ref('new'), availableTexts.value, 'id');

    watch(text, () => {
        command.payload.textName = text.value.name ?? '';
        command.payload.text = text.value.text ?? '';
    }, { immediate: command instanceof CreateDocumentTemplateCommand });

    const layoutCollection = await getReactiveCollection(Layout, {
        active: true,
        editable: true,
        type: documentType.value,
        'order[name]': 'asc',
    });

    const availableLayouts = computed(() => layoutCollection.data.value);
    const layout = useScalarSelectInput(toRef(command, 'layoutId'), availableLayouts.value, 'id');
    if (!layout.value && availableLayouts.value.length && isEditable.value) {
        layout.value = availableLayouts.value[0].id;
        documentPlaceholder.value = availableLayouts.value[0].name;
    }

    watch(layout, () => {
        isConfigurable.value = layout?.value?.configurable;
    });

    const backToLister = () => {
        router.push({ name: 'documentTemplateList' });
    };

    const saveTemplate = async (event: ButtonStateChangedEvent) => {
        try {
            notifySaving();
            await client.dispatch(command);
            notifySaved();
            backToLister();
        } catch (error) {
            notifyError(error);
        } finally {
            event.button.setState(ButtonState.completed);
        }
    };

    const changeLogoModal = ref<ExposedOverlay>();
    const changeLogoModalFiles = ref([]);
    const changeLogoModalLogo = ref<DocumentLogo | null>(null);

    const uploadLogo = async (files: File[]) => {
        const file = files.pop();
        if (!file) {
            return;
        }

        const createLogoCommand = CreateDocumentLogoCommand.create();
        createLogoCommand.companyId = currentCompany.value?.id.value ?? '';
        createLogoCommand.file = file;

        await client.dispatch(createLogoCommand);

        changeLogoModalLogo.value = await client.get(DocumentLogo, createLogoCommand.id);
    };

    const onChangeLogoDelete = () => {
        changeLogoModalLogo.value = null;
    };

    const onChangeLogoCancel = () => {
        changeLogoModalLogo.value = null;
        changeLogoModal.value?.closeOverlay();
    };

    const onChangeLogoConfirm = () => {
        logo.value = changeLogoModalLogo.value;
        changeLogoModalLogo.value = null;
        changeLogoModal.value?.closeOverlay();
    };

    const preview = ref('');

    const previewCommand = computed(() => {
        const result = PreviewDocumentTemplateCommand.create();
        result.companyId = currentCompany.value?.id.value ?? '';
        result.layoutId = command.layoutId;
        result.logoId = command.logoId;
        result.payload = command.payload;

        return result;
    });
    const previewCommandIsValid = computed(() => previewCommand.value.validationSchema.isValidSync(previewCommand.value));

    const refreshPreview = async () => {
        if (!previewCommandIsValid.value) {
            return;
        }

        preview.value = await client.dispatch(previewCommand.value);
    };

    watch(previewCommand, lodash.debounce(refreshPreview, 400, { maxWait: 2000 }), { deep: true, immediate: true });
</script>

<style scoped lang="scss">
.logo-preview {
    max-height: 96px;
    max-width: 100%;
    padding: 2rem;

    &--change-modal {
        max-height: 384px;
    }
}
</style>
